module.exports = __webpack_public_path__ + "static/media/carousel-8.7403ac88.jpg";